<template>
  <a-modal
    title="查看参数列表"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    :footer="null"
  >
    <a-table
      :columns="columns"
      :loading="pageParams.tableLoading"
      :data-source="tableList"
      :pagination="false"
      row-key="id"
      :scroll="{ y: 230 }"
    >
    </a-table>
    <!-- 底部分页按钮 -->
    <Page ref="pageParamter" :pageParams.sync="pageParams" @getList="getList" />
  </a-modal>
</template>

<script>
export default {
  props: {},
  data () {
    return {
      visible: false,
      pageParams: {
        automatic: false,
        pageUrl: '/system/lookup/data/list',
        tableLoading: false
      },
      queryParams: {
        lookupType: "SCP_PLAN_PARAMETERS"
      },
      columns: [
        {
          title: '参数名称',
          dataIndex: 'lookupValue'
        },
        {
          title: '说明',
          dataIndex: 'remark'
        }
      ],
      tableList: []
    }
  },
  created () {},
  methods: {
    // 参数名称排序
    recursion (data) {
      data.map(e => {
        if (e.children) {
          e.children.sort(function (a, b) { return a.lookupValue.localeCompare(b.lookupValue, 'zh-CN') })
          this.recursion(e.children)
        }
      })
      return data
    },
    /** 查询列表 */
    getList (arr) {
      arr.sort(function (a, b) { return a.lookupValue.localeCompare(b.lookupValue, 'zh-CN') })
      arr = this.recursion(arr)
      this.tableList = arr
    },
    show () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.pageParamter.getFirstPage(this.queryParams)
      })
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 表单重置
    reset () {
      this.tableList = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
